import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { userManager } from './AuthProvider';

export default function AuthCallback() {
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        await userManager.signinRedirectCallback();
      } finally {
        navigate('/', { replace: true });
      }
    })();
  }, [navigate]);

  return <div>Signing in…</div>;
}
